import useT from "utils/hooks/useT"

// Temporary section body shown until each LIMS section's feature is implemented
// (F-B/F-C/F-D). Pass `titleKey` (i18n key) for sections, or a literal `title`.
// Inherits the app's heading font/color to match the rest of Plannertech.
export default function LimsPlaceholder({ titleKey, title }) {
  const { t } = useT("common")
  return (
    <div className="LimsPlaceholder">
      <h1>{title || t(titleKey)}</h1>
      <p>{t("limsComingSoon")}</p>
    </div>
  )
}
